import { createContext, useContext } from 'react';

export type LogEntry = {
  message: string;
  timestamp: number;
};

type TLogStoreContext = {
  actions: {
    add: (message: string) => Promise<void>;
    getLogsToSend: () => Promise<LogEntry[]>;
    markLogsAsSentAndPrune: (latestTimestamp: number) => Promise<void>;
  };
};

const Context = createContext<TLogStoreContext>({
  actions: {
    add: (_message: string) => Promise.resolve(),
    getLogsToSend: () => Promise.resolve([]),
    markLogsAsSentAndPrune: (_latestTimestamp: number) => Promise.resolve(),
  },
});

export default Context;

export const useLogStoreContext = () => useContext(Context);
